define('bootstrapping/browserSupportTask',['browserSupport'], function (browserSupport) {
    return {
        execute: function () {
            browserSupport.initialize();
        }
    };
});
